module.exports = __webpack_public_path__ + "img/Gender.4d1a9466.svg";